// TODO: Fix Vue App type import when available
// import type { App } from 'vue';
import { useNotifications } from '@/composables/useNotifications';

/**
 * Plugin Vue.js pour intégrer le système de notifications globalement
 * Ajouter $notify à l'instance Vue pour un accès facile dans les composants
 */
export default {
  install(app: any): void { // TODO: Use proper App type when available
    // Créer une instance unique pour l'application
    const notifications = useNotifications();
    
    // Ajouter les méthodes de notification à l'instance globale
    app.config.globalProperties.$notify = {
      success: notifications.notifySuccess,
      error: notifications.notifyError,
      warning: notifications.notifyWarning,
      info: notifications.notifyInfo,
      confirm: notifications.notifyConfirm,
      withAction: notifications.notifyWithAction,
      clear: notifications.clearAllNotifications
    };

    // Also expose the notification methods on window so non-Vue modules (utils/globalNotifications)
    // can call the same implementation and push UI notifications into the composable's store.
    if (typeof window !== 'undefined') {
      type WinNotifiers = {
        notifySuccess?: typeof notifications.notifySuccess
        notifyError?: typeof notifications.notifyError
        notifyWarning?: typeof notifications.notifyWarning
        notifyInfo?: typeof notifications.notifyInfo
        notifyConfirm?: typeof notifications.notifyConfirm
        notifyWithAction?: typeof notifications.notifyWithAction
        clearAllNotifications?: typeof notifications.clearAllNotifications
      }

      const win = window as unknown as WinNotifiers

      win.notifySuccess = notifications.notifySuccess
      win.notifyError = notifications.notifyError
      win.notifyWarning = notifications.notifyWarning
      win.notifyInfo = notifications.notifyInfo
      win.notifyConfirm = notifications.notifyConfirm
      win.notifyWithAction = notifications.notifyWithAction
      win.clearAllNotifications = notifications.clearAllNotifications
    }
    // Fournir le composable via provide/inject
    app.provide('notifications', notifications);
  }
};
